import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';  // ✅ Fixed path
import '../cssstyle/ThemeToggle.css';

const ThemeToggleLeft = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div>
      <button className="theme-toggle-left flex items-center gap-2" onClick={toggleDarkMode}>
        {darkMode ? (
          <>
            <FaSun />
            <span className="text-sm">Light Mode</span>
          </>
        ) : (
          <>
            <FaMoon />
            <span className="text-sm">Dark Mode</span>
          </>
        )}
      </button>
    </div>
  );
};

export default ThemeToggleLeft;